<template>
  <div>
    <w-form-checkbox
      v-model="internalValue"
      :class="{ 'w-toggleable-content--read-only': readonly, 'pa-3': true }"
      :label="label"
      :disabled="readonly || disableCheckbox"
      hide-details
    />
    <slot
      v-if="internalValue"
      name="content"
    />
  </div>
</template>

<script>
export default {
  model: {
    event: 'change'
  },
  props: {
    value: null,
    disableCheckbox: Boolean,
    label: String,
    readonly: Boolean
  },
  data() {
    return {
      lazyValue: this.value
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.lazyValue;
      },
      set(val) {
        if (val != this.lazyValue) {
          this.lazyValue = val;
          this.$emit('change', val);
        }
      }
    }
  },
  watch: {
    value(val) {
      this.lazyValue = val;
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .w-toggleable-content--read-only {
  & .v-label.v-label--is-disabled {
    @include w-p3;
  }
}
</style>
